import React, { useState } from 'react'
import { Empty, Table, Tooltip } from 'antd'
import { Button } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileLines, faCalendarPlus } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import 'moment/locale/es'

import OrderDrawer from './OrderDrawer'
import Pagination from '../../../components/Pagination'
import NewAppointmentModal from '../../Appointments/partials/NewAppointmentModal'

export default function OrdersTable({ orders, reload, pagination, setPagination }) {	
	const [orderDrawer, setOrderDrawer] = useState(null)
	const [showAppointmentModal, setShowAppointmentModal] = useState(null)

	const columns = [
		{
			title: 'Consecutivo',
			dataIndex: 'sku'
		},
		{
			title: 'Tipo de Orden',
			dataIndex: 'order_type',
		},
		{
			title: 'Fecha Orden',
			dataIndex: 'registered_at',
			render: t => t ? `${t} (${moment(t).fromNow()})` : <em>Sin registro</em>
		},
		{
			title: 'Items',
			dataIndex: 'order_details',
			render: t => t.length
		},
		{
			title: 'Bodega Asociada',
			dataIndex: 'location_sku',
		},
		{
			title: 'Acciones',
			render: (t, r) => (
				<React.Fragment>
                    <Button onClick={() => setOrderDrawer(r)} color="primary" outline size="sm" className='mr-5'>
                    	<Tooltip title="Ver detalles">
                            <FontAwesomeIcon icon={faFileLines} />
                    	</Tooltip>
                    </Button>
					{ r.is_pending_appointment && (
						<Button onClick={() => setShowAppointmentModal(r)} color="primary" outline size="sm">
							<Tooltip title="Agendar cita">
								<FontAwesomeIcon icon={faCalendarPlus} />
							</Tooltip>
						</Button>
					)}
				</React.Fragment>
			)
		}
	]
	
	return (
		<React.Fragment>
			<Table 
				dataSource={orders}
				rowKey={r => r.id}
				pagination={false}
				columns={columns}
				loading={!orders}
				size="small"
				locale={{ emptyText: (
					<Empty
						description="No se encontraron registros" 
						imageStyle={{ height: '80px' }}
					/> 
				)}}
			/>
			<Pagination 
				pagination={pagination}
				updatePagination={setPagination}
				reload={reload}
				className="mb-0"
			/>
			{ orderDrawer && (
				<OrderDrawer 
					visible
					onClose={() => setOrderDrawer(null)}
					order={orderDrawer}
				/>
			)}
			{ showAppointmentModal && (
				<NewAppointmentModal
					visible
					onClose={() => setShowAppointmentModal(null)}
					reload={reload}
					defaultOrder={showAppointmentModal}
				/>
			)}
		</React.Fragment>
	)
}